import React, { createContext, useContext, useState } from "react"
import { AlertColor } from "@mui/material"

interface SnackbarState {
  open: boolean
  message: string
  type: AlertColor
}

interface SnackbarContextType {
  snackbar: SnackbarState
  showSnackbar: (message: string, type?: AlertColor) => void
  hideSnackbar: () => void
}

const SnackbarContext = createContext<SnackbarContextType>({
  snackbar: { open: false, message: "", type: "info" },
  showSnackbar: () => {},
  hideSnackbar: () => {}
})

const SnackbarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [snackbar, setSnackbar] = useState<SnackbarState>({ open: false, message: "", type: "info" })

  const showSnackbar = (message: string, type: AlertColor = "info") => {
    setSnackbar({ open: true, message, type })
  }

  const hideSnackbar = () => {
    setSnackbar(s => ({ ...s, open: false }))
  }

  return (
    <SnackbarContext.Provider value={{ snackbar, showSnackbar, hideSnackbar }}>{children}</SnackbarContext.Provider>
  )
}

const useSnackbar = (): SnackbarContextType => useContext(SnackbarContext)

export { SnackbarProvider, useSnackbar }
export type { SnackbarContextType, SnackbarState }
